import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "2010 - 2014",
      title: "B.Sc (Hons) Special in Computer Science",
      place: "University of Sri Jayewardenepura",
      desc: "I completed a bachelor's degree in 2013 with Second Class Honors (Upper Division) with a Grade Point Average of 3.2.",
    },
    // {
    //   yearRange: "2014 - 2015",
    //   title: "Bachelor in Computer Engineering",
    //   place: "University of California",
    //   desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    // },
    // {
    //   yearRange: "2013 - 2014",
    //   title: "International Science",
    //   place: "Harvard University",
    //   desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    // },
  ];
  const AchievementDetails = [
    {
      yearRange: "2023 - present",
      title: "AWS Community Builder",
      place: "Amazon Web Services (AWS)",
    },
    {
      yearRange: "2020",
      title: "Certified AWS Solutions Architect - Associate",
      place: "Amazon Web Services (AWS)",
    },
    {
      yearRange: "2009",
      title: "Sun Certified Programmer Java 2 Platform, SE 5.0",
      place: "Sun Microsystems",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "2022 - current",
      title: "Senior Engineer",
      place: "Xero",
      desc: "I maintain internal production systems that are mission critical for the everyday engineering operations. Mainly I look after multiple CI/CD instances including 1000s of their build agents and I take care of multiple artifact repositories.",
    },
    {
      yearRange: "2021 - 2022",
      title: "Senior Engineer",
      place: "Westpac NZ",
      desc: "I worked as a DevOps specialist for the Forensic Analysis team, I was helping them to migrate their analysis tools from monolith on-prem to Kubernetes.",
    },
    {
      yearRange: "2019 - 2021",
      title: "Senior Engineer",
      place: "Spark NZ",
      desc: "I developed and maintained the cloud infrastructure for multiple Big Data projects for many New Zealand customers .",
    },
    {
      yearRange: "2018 - 2019",
      title: "Engineer",
      place: "Datacom",
      desc: "I developed and maintained cloud infrastructure for various integration projects. Mainly helped to get NZ the government departments to start with their cloud journey.",
    },
    {
      yearRange: "2016 - 2018",
      title: "Senior Engineer",
      place: "WSO2",
      desc: "I was one of the founding members of the WSO2 Cloud effort. Helped build WSO2 Cloud from scratch and keeping it alive for many years.",
    },
    {
      yearRange: "2014 - 2016",
      title: "Engineer",
      place: "WSO2",
      desc: "I was part of the engineering team that developed WSO2 Middleware stack. Helped developing and supporting many WSO2 Middleware products even in the customer use cases.",
    },    
  ];

  const skills = [
    {
      name: "AWS",
      percent: 95,
    },
    {
      name: "GCP",
      percent: 80,
    },
    {
      name: "Azure",
      percent: 70,
    },
    {
      name: "Kubernetes",
      percent: 80,
    },
    {
      name: "Docker",
      percent: 90,
    },
    {
      name: "Python",
      percent: 90,
    },
    {
      name: "Bash",
      percent: 85,
    },
    {
      name: "terraform",
      percent: 90,
    },
    {
      name: "Ansible",
      percent: 75,
    },
    {
      name: "JavaScript",
      percent: 80,
    },
  ];

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resume</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A summary of My Resume
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5">
          {/* My Education */}
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
            <h2 className="text-7 fw-600 mb-4 pb-2">My Achievements</h2>
            <div className="border-start border-2 border-primary ps-3">
              {AchievementDetails.length > 0 &&
                AchievementDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
          {/* My Experience */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">My Skills</h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div className="col-md-6 wow fadeInUp" key={index}>
                <p className="fw-500 text-start mb-2">
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div className="progress progress-sm mb-4">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-dark shadow-none rounded-0"
            href={resumeFile}
            download
          >
            Download CV
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
